import Spinner from "react-bootstrap/Spinner";

function Spinners(prop) {
  return (
    <Spinner
      style={{
        marginLeft: prop.width ? prop.width : "50%",
        marginTop: "10px",
      }}
      animation="border"
      varient="primary"
    />
  );
}

export default Spinners;
